export function reloadPage(): void {
  window.location.reload();
}

export function navigateTo(url: string): void {
  window.location.assign(url);
}

export function replaceUrl(url: string): void {
  window.location.replace(url);
}
